import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import NotificationBase from '../NotificationBase/NotificationBase';
import styles from './NotificationInline.module.css';
const NotificationInline = props => {
  return /*#__PURE__*/React.createElement(NotificationBase, props);
};

// TODO: убрать в мажорном обновлении
NotificationInline.defaultProps = _extends({}, NotificationBase.defaultProps, {
  dataQaType: 'uikit/NotificationInline',
  modStyles: styles,
  durationCollapse: 250,
  paddingBottom: 0
});
export default NotificationInline;